let userHasInteractedWithSize =
  !document.querySelector('.sh-size-dropdown');

function updateStickyBar() {

  const stickyPrice = document.getElementById('shStickyPrice');
  const stickySize = document.getElementById('shStickySize');
  const stickyButton = document.getElementById('shStickyButton');

  if (!stickyPrice || !stickySize) return;

  const salePrice = document.querySelector(
    '.sh-main-price .price-item--sale'
  );

  const regularPrice = document.querySelector(
    '.sh-main-price .price-item--regular'
  );

  if (salePrice) {

    stickyPrice.textContent =
      salePrice.textContent.trim();

  } else if (regularPrice) {

    stickyPrice.textContent =
      regularPrice.textContent.trim();

  }

  const selectedSize = document.querySelector(
    '.sh-size-dropdown__selected'
  );

  if (!userHasInteractedWithSize) {

    stickySize.textContent = '';

  } else if (selectedSize) {

  const sizeLabel =
    stickyButton.dataset.sizeLabel;

  stickySize.textContent =
    sizeLabel + ' ' +
    selectedSize.textContent.trim();

  } else {

    stickySize.textContent = '';

  }
  
  if (stickyButton) {

  stickyButton.textContent =
    userHasInteractedWithSize
      ? stickyButton.dataset.addToCart
      : stickyButton.dataset.chooseSize;

  }
}

document.addEventListener('DOMContentLoaded', () => {

  updateStickyBar();

});

document.addEventListener('change', (event) => {

  if (
    event.target &&
    event.target.matches('select[name^="options["]')
  ) {

    userHasInteractedWithSize = true;

  }

  setTimeout(() => {
    updateStickyBar();
  }, 50);

});

document.addEventListener(
  'sh:size-interacted',
  () => {

    userHasInteractedWithSize = true;

    updateStickyBar();

  }
);

document.addEventListener('DOMContentLoaded', () => {

  const stickyBar = document.querySelector('.sh-sticky-atc');
  const mainButton = document.querySelector('.product-form__submit');

  if (!stickyBar || !mainButton) return;

  const observer = new IntersectionObserver(

    (entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          stickyBar.classList.remove(
            'sh-sticky-atc--visible'
          );

        } else {

          stickyBar.classList.add(
            'sh-sticky-atc--visible'
          );

        }

      });

    },

    {
      threshold: 0.1
    }

  );

  observer.observe(mainButton);

});

document.addEventListener('click', (event) => {

  const stickyButton =
    event.target.closest('#shStickyButton');

  if (!stickyButton) return;

  if (!userHasInteractedWithSize) {

    const sizeSelector =
      document.querySelector(
        '.sh-size-dropdown'
      );

    if (sizeSelector) {

      sizeSelector.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

    }

    return;

  }

  const realAddToCartButton =
    document.querySelector(
      '.product-form__submit'
    );

  if (
    realAddToCartButton &&
    !realAddToCartButton.disabled
  ) {

    realAddToCartButton.click();

  }

});